import axios from '../../../axios';
const url = '/api';

export const getBusinessUnit = () => axios.get(`${url}/get-business-units-settings`);
